/** @format */

import React, { PureComponent } from 'react';
import { JDDevice, JDRouter, JDLoadingView, JDText, JDImage } from '@jdreact/jdreact-core-lib';
const { Router, Route } = JDRouter;
import { observer } from 'mobx-react';
import { StyleSheet, View, Platform } from 'react-native';
// 商品对比页
import GoodsContrastPage from './pages/GoodsContrastPage';
import AddGoodsContrastPage from './pages/AddGoodsContrastPage';
import SelectContrastGoodsPage from './pages/SelectContrastGoodsPage';
import store from './services/goodsContrastPageStore/store';
import { IUrlParams } from './services/goodsContrastPageStore/domain';
import getQueryString from './utils/getQueryString';
import Images from './images';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  loading: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: getRpx(750),
    height: '100%',
  },
  wrap: {
    alignItems: 'center',
    width: getRpx(750),
    height: JDDevice.height,
    backgroundColor: '#f7f7f7',
  },
  textPlacehodler: {
    fontSize: getFontSize(30),
    color: '#BFBFBF',
  },
  noDataPlaceholder: {
    width: getRpx(308),
    height: getRpx(308),
    marginTop: getRpx(223),
    marginBottom: getRpx(30),
  },
});
interface IProps {
  skuId: string;
  cateId: string;
  action: string;
  client: string;
  store: {
    cateId: string;
    action: string;
    client: string;
    golbalSku: string;
    showPopup: boolean;
    Dataloaded: boolean;
    initUrlParam: (param: IUrlParams) => void;
    initCategory: () => void;
    getDataBySku: () => void;
    addGoods: () => void;
    getDataByCateId: (cateId: string) => void;
    setReadOnly: (isReadOnly: boolean) => void;
  };
}
interface IState {
  ready: boolean;
}

export default class JDReactGoodsContrast extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      ready: false,
    };
    if (Platform.OS != 'web') {
      this.props.store.initUrlParam({
        skuId: this.props.skuId ? this.props.skuId : '',
        cateId: this.props.cateId ? this.props.cateId : '',
        action: this.props.action ? this.props.action : '',
        client: this.props.client ? this.props.client : '',
      });
    } else {
      let skuId = getQueryString('skuId');
      let cateId = getQueryString('cateId');
      let action = getQueryString('action');
      let client = getQueryString('client');

      this.props.store.initUrlParam({
        skuId: skuId ? skuId : '',
        cateId: cateId ? cateId : '',
        action: action ? action : '',
        client: client ? client : '',
      });
    }

    this.props.store.initCategory();
  }

  componentDidMount() {
    // JDNativeSystem.getClientVersion()
    //   .then(null, () => 'UNKNOWN')
    //   .then((version) => {
    //     globalParams.APP_CLIENT_VERSION = version;
    //     this.setState({
    //       ready: true,
    //     });
    //   });

    if (Platform.OS != 'web') {
      this.appInit();
    } else {
      this.webInit();
    }
  }
  appInit = () => {
    const { client } = this.props;
    const map = new Map();
    map.set('app', this.fromAppOpen);
    map.set('h5', this.fromH5Open);
    map.get(client)();
  };
  webInit = () => {
    const { store } = this.props;
    store.setReadOnly(true);
    if (store.golbalSku !== '') {
      store.getDataBySku();
    }
  };
  fromAppOpen = () => {
    const { store, action, cateId } = this.props;
    //app 进入的场景 仅为商详页面添加商品时进入 action:1为添加商品
    store.setReadOnly(false);
    if (action == '1') {
      store.addGoods();
    } else {
      store.getDataByCateId(cateId);
    }
  };
  fromH5Open = () => {
    //h5 进入的场景为 从分享页面唤起 app 进入 且 暴露我的对比 入口 详情变为只读
    const { store } = this.props;
    store.getDataBySku();
    store.setReadOnly(true);
  };
  render() {
    const { store } = this.props;
    const { showPopup, Dataloaded, action, cateId, client, golbalSku } = store;
    const initRoute = Dataloaded ? { key: showPopup ? 'selectContrastGoods' : 'goodsContrast' } : '';
    if (Platform.OS == 'web' && (!golbalSku || !action || !cateId)) {
      return (
        <View style={styles.wrap}>
          <JDImage source={Images.common.placeholder} style={styles.noDataPlaceholder}></JDImage>
          <JDText style={styles.textPlacehodler}>暂无数据,请稍后重试</JDText>
        </View>
      );
    }

    if (!Dataloaded) {
      return (
        <View style={styles.loading}>
          <JDLoadingView></JDLoadingView>
        </View>
      );
    }
    return (
      <Router initRoute={initRoute}>
        <Route
          key="goodsContrast"
          type="resetTo"
          sceneConfig={Router.SceneConfigs.None}
          component={GoodsContrastPage}
        />
        <Route key="addGoodsContrast" type="push" component={AddGoodsContrastPage} />
        <Route key="selectContrastGoods" component={SelectContrastGoodsPage} />
      </Router>
    );
  }
}
const JDReactGoodsContrastOberver = observer(JDReactGoodsContrast);
const JDReactGoodsContrastWapper = (props: IProps) => <JDReactGoodsContrastOberver {...props} store={store} />;

module.exports = JDReactGoodsContrastWapper;
